import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/content/homepage/homepage'
import BandStory from '@/components/content/BandStory'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/bandStory',
      name: 'BandStory',
      component: BandStory
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js